import React from "react";
import { useNavigate } from "react-router-dom";

import Table from "../../../../tables/components/Table";
import InstantSearchConfigure from "../../../../ui/components/InstantSearch/InstantSearchConfigure";
import { InstantSearchHits } from "../../../../ui/components/InstantSearch/InstantSearchData";
import InstantSearchIndex from "../../../../ui/components/InstantSearch/InstantSearchIndex";

import useSeriesDropdownMenuOptions from "../../../hooks/useSeriesDropdownMenuOptions";
import useSeriesTableColumns from "../../../hooks/useSeriesTableColumns";

export default function SeriesTable({ data: series }) {
	const navigate = useNavigate();

	const columns = useSeriesTableColumns();
	const getDropdownMenuOptions = useSeriesDropdownMenuOptions();

	const filters = series.map(({ id }) => `serie.id:${id}`).join(" OR ");

	return (
		<InstantSearchIndex indexName="works">
			<InstantSearchConfigure filters={filters} />

			<InstantSearchHits>
				{({ data: works }) => {
					return (
						<Table
							data={series.map((serie) => ({
								id: serie.id,
								serie,
								works: works.filter((work) => work.serie?.id === serie.id),
							}))}
							columns={columns}
							onClick={({ id }) => navigate(id)}
							getDropdownMenuOptions={getDropdownMenuOptions}
						/>
					);
				}}
			</InstantSearchHits>
		</InstantSearchIndex>
	);
}
